var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { font, color, media, FONT_STRINGS } from '../../styles';
export var propValueFromTextSize = function (prop, index) {
    if (prop === void 0) { prop = 'fontSize'; }
    return function (props) {
        var value = props.theme.textSizes[props.size][prop];
        return Array.isArray(value) ? value[index] : value;
    };
};
var getTextColor = function (props) { return props.color || 'secondaryBrand'; };
var InnerTextComponent = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0;\n  vertical-align: middle;\n  display: block;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0;\n  vertical-align: middle;\n  display: block;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
    return font(props.font || propValueFromTextSize('font')(props));
}, function (props) {
    return (props.fontWeight && props.theme.fontWeights[props.fontWeight]) ||
        propValueFromTextSize('fontWeight', 0);
}, function (props) { return color(getTextColor(props)); }, propValueFromTextSize('fontSize', 0), propValueFromTextSize('lineHeight', 0), function (props) {
    return props.truncate &&
        "\n  text-align: left;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  ";
}, media.large(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), propValueFromTextSize('fontSize', 1), propValueFromTextSize('lineHeight', 1)), function (p) { return p.css; });
var tagForSize = {
    h1_new: 'h1',
    h2_new: 'h1',
    h3_new: 'h1',
    h4_new: 'h2',
    h5_new: 'h2',
    body1_new: 'p',
    body2_new: 'p',
    caption_new: 'p'
};
var Text = function (props) { return (_jsx(InnerTextComponent, __assign({}, props, { as: props.as || props.textAs || (props.size && tagForSize[props.size]) || 'p' }, (props.htmlParams || {})))); };
Text.defaultProps = {
    size: 'body1_new',
    as: undefined,
    color: undefined
};
export var InlineText = styled.span(function (props) {
    var _a, _b, _c, _d;
    return ({
        color: props.color ? props.theme.color[props.color] : undefined,
        fontFamily: FONT_STRINGS[(_a = props.font) !== null && _a !== void 0 ? _a : 'Inter'],
        fontSize: props.theme.textSizes[(_b = props.size) !== null && _b !== void 0 ? _b : 'body2_new'].fontSize[0],
        fontWeight: props.theme.fontWeights[(_c = props.fontWeight) !== null && _c !== void 0 ? _c : 'regular'],
        lineHeight: props.theme.textSizes[(_d = props.size) !== null && _d !== void 0 ? _d : 'body2_new'].lineHeight[0]
    });
});
export var BlockText = styled(InlineText).attrs(function () { return ({
    as: 'div'
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export default Text;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map